import PropTypes from 'prop-types';
import {Enums} from '_app/utils';

const reviewStatuses = Enums.getType('reviewStatuses');

export default PropTypes.shape({
	complianceId: PropTypes.number,
	createDate: PropTypes.instanceOf(Date),
	deleteDate: PropTypes.instanceOf(Date),
	disclaimer: PropTypes.string,
	id: PropTypes.number,
	mediaId: PropTypes.number,
	modifyDate: PropTypes.instanceOf(Date),
	partnerId: PropTypes.string,
	status: PropTypes.oneOf([
		reviewStatuses.TO_BE_REVIEWED,
		reviewStatuses.DENIED,
		reviewStatuses.ACTION_REQUIRED,
		reviewStatuses.APPROVED
	]),
	version: PropTypes.number
});